import { useTable, useSortBy, useFlexLayout, useRowSelect } from "react-table";
import { useMemo } from "react";

const useCommonTable = (data: any = [], columns: any) => {
  const memoizedColumns = useMemo(() => columns, [columns]);
  const memoizedData = useMemo(() => data, [data]);

  const tableInstance = useTable(
    {
      columns: memoizedColumns as any,
      data: memoizedData,
      autoResetSortBy: false,
      autoResetFilters: false,
      autoResetRowState: false,
      autoResetHiddenColumns: false,
      autoResetExpanded: false,
      autoResetGroupBy: false,
      autoResetSelectedRows: false,
      autoResetPage: false,
      autoResetPageSize: false,
    },
    useSortBy,
    useRowSelect,
    useFlexLayout
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    rows,
    allColumns,
    toggleHideAllColumns,
    selectedFlatRows,
    toggleAllRowsSelected,
    getToggleAllRowsSelectedProps,
  } = tableInstance;

  return {
    columns: memoizedColumns,
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    prepareRow,
    rows,
    allColumns,
    toggleHideAllColumns,
    selectedFlatRows,
    getToggleAllRowsSelectedProps,
    toggleAllRowsSelected,
  };
};

export default useCommonTable;
